export const ADD_TO_BASKET = 'ADD_TO_BASKET'
export const REMOVE_BASKET_ITEM = 'REMOVE_BASKET_ITEM'
export const TOGGLE_BASKET_ITEM_AMOUNT = 'TOGGLE_BASKET_ITEM_AMOUNT'
export const CLEAR_BASKET = 'CLEAR_BASKET'
export const COUNT_BASKET_TOTALS = 'COUNT_BASKET_TOTALS'
